/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description: Mission Phases component step 3 of the mission creation 
Author: Deimos Space UK

Version: 1.0
*/

import React, { useState, useEffect } from 'react'
import { Row, Col, Button, Card, Accordion, Container } from 'react-bootstrap';
import Select from 'react-select';
import db from '../../../../utils/db/db';
import ManualInput from './ManualInput/ManualInput';
import style from './MissionPhases.module.css'
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import classNames from 'classnames';
import FileUpload from '../../../../core/components/FileUpload/FileUpload';
import JSZip from 'jszip'
import { postPetition } from '../../../../api/api'
import { useNavigate } from 'react-router-dom'
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

import KeplerianInputs from '../PMDphases/KeplerianInputs/KeplerianInputs'
import GeneralInputs from '../PMDphases/GeneralInputs/GeneralInputs'

function MissionPhases(props) {
  const [orbits, setNOrbits] = useState(0)
  const [step3, setStep3] = useState([])

  const [step4, setStep4] = useState([])
  const [change, setChange] = useState(false)
  const [loading, setLoading] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const [architectureType, setArchitectureType] = useState('')
  const navigate = useNavigate()
  const location = useLocation()
  const [launcherType, setlauncherType] = useState('')
  const [kingHele, setKingHele] = useState(false)



  useEffect(() => {
    const data = sessionStorage.getItem('firstStep');
    if (data) {
      setLoading(false)
      const step1 = JSON.parse(data)
      setArchitectureType(step1.architectureType)
      if (step1.architectureType === 'constellation') {
        setNOrbits(parseFloat(step1.nOrbits))
      } else {
        setNOrbits(1)
      }
      setLoading(true)
    }
  }, [])
  useEffect(() => {
    setLoading(false)
    const nOrbits = []
    const data = sessionStorage.getItem('thirdStep');
    const step4_ = sessionStorage.getItem('fourthStepConstellation');
    const step4Launcher = sessionStorage.getItem('fourthStep');
    if (data) {
      const step3 = JSON.parse(data);
      setStep3(step3)
    } else {
      for (let i = 0; i < orbits; i++) {
        let newStep3 = {
          id: i,
          launchPhase: [{}],
          operationalOribitInjectionPhase: [{}],
          operationalPhase: [{}],
        }
        nOrbits.push(newStep3)
      }
      setStep3(nOrbits)
    }

    if (architectureType === 'constellation' || architectureType === 'launcher') {
      if (step4_) {
        const step4 = JSON.parse(step4_);
        setStep4(step4)
      } else if (step4Launcher) {
        const step4 = JSON.parse(step4Launcher);
        if (step4.startEpoch) {
          setlauncherType('base')
        }
        setStep4([step4])
      }
      else {
        const newStep4 = []
        for (let i = 0; i < orbits; i++) {
          newStep4.push({
            startEpoch: '',
            semiMajorAxis: '',
            meanAnomaly: '',
            eccentricity: '',
            inclination: '',
            rightAscension: '',
            argumentOfPerigee: '',
            crossSection: '',
            dragCoefficient: '2.2',
            reflectivityCoefficient: '1.3',
          })
        }
        setStep4(newStep4)
      }
    }
    setLoading(true)

  }, [orbits])

  useEffect(() => {
    if (props.id) {
      if (location.pathname.includes('clone')) {
        setDisabled(false)
      } else {
        setDisabled(true)
      }
    }
  }, [props.id, location.pathname])

  const validateForm = () => {
    let valid = true
    if (architectureType === 'launcher') {
      return false
    }
    step3.forEach((orbit, index) => {
      if (orbit.launchPhase.length > 0) {
        orbit.launchPhase.forEach((phase, index2) => {
          if (Object.keys(phase).length === 0) {
            valid = false
          }
          if (phase.type === 'file' && phase.data === '') {
            valid = false

          } else if (phase.type === 'base') {
            if (phase.keplerian.raan === '' || phase.keplerian.sma === '' || phase.keplerian.eccentricity === '' || phase.keplerian.mean_anomaly === '' || phase.keplerian.argument_perigee === '' || phase.keplerian.inclination === '' || phase.start_epoch === '' || phase.end_epoch === '') {
              valid = false
            }
          }
        })
      }
      if (orbit.operationalOribitInjectionPhase.length > 0) {
        orbit.operationalOribitInjectionPhase.forEach((phase, index2) => {
          if (Object.keys(phase).length === 0) {
            valid = false
          }
          if (phase.type === 'file' && phase.data === '') {
            valid = false

          } else if (phase.type === 'base') {
            if (phase.keplerian.raan === '' || phase.keplerian.sma === '' || phase.keplerian.eccentricity === '' || phase.keplerian.mean_anomaly === '' || phase.keplerian.argument_perigee === '' || phase.keplerian.inclination === '' || phase.start_epoch === '' || phase.end_epoch === '') {
              valid = false
            }
          }
        })
      }
      if (orbit.operationalPhase.length > 0) {

        orbit.operationalPhase.forEach((phase, index2) => {
          if (Object.keys(phase).length === 0) {
            valid = false
          }
          if (phase.type === 'file' && phase.data === '') {
            valid = false

          } else if (phase.type === 'base') {
            if (phase.keplerian.raan === '' || phase.keplerian.sma === '' || phase.keplerian.eccentricity === '' || phase.keplerian.mean_anomaly === '' || phase.keplerian.argument_perigee === '' || phase.keplerian.inclination === '' || phase.start_epoch === '' || phase.end_epoch === '') {
              valid = false
            }
          }
        })
      }
    })
    return !valid

  }

  const addOperationalInjectionPhase = (index) => {
    const newStep3 = [...step3]
    newStep3[index].operationalOribitInjectionPhase.push({

    })
    setStep3(newStep3)
    setChange(!change)
  }

  const addOperationalPhase = (index) => {
    const newStep3 = [...step3]
    newStep3[index].operationalPhase.push({})
    setStep3(newStep3)
    setChange(!change)
  }

  const removeOperationalInjectionPhase = (index, index2) => {
    const newStep3 = [...step3]
    newStep3[index].operationalOribitInjectionPhase.splice(index2, 1)
    setStep3(newStep3)
    setChange(!change)
  }

  const removeOperationalPhase = (index, index2) => {
    const newStep3 = [...step3]
    newStep3[index].operationalPhase.splice(index2, 1)
    setStep3(newStep3)
    setChange(!change)
  }

  const onChangeLauncherType = (value, index, phase, index2) => {
    const newStep4 = [...step4]
    const newStep3 = [...step3]
    if (value.value === 'file') {
      newStep3[index][phase][index2] = {
        data: "",
        type: "file",
      }
    } else {
      newStep4[index] = {
        startEpoch: '',
        semiMajorAxis: '',
        meanAnomaly: '',
        eccentricity: '',
        inclination: '',
        rightAscension: '',
        argumentOfPerigee: '',
        crossSection: '',
        dragCoefficient: '2.2',
        reflectivityCoefficient: '1.3',
      }
    }
    if (value.value === 'king_hele') {
      setKingHele(true)
    } else {
      setKingHele(false)
    }
    setStep4(newStep4)
    setStep3(newStep3)
    setlauncherType(value.value)
    setChange(!change)
  }

  const onChangeInputType = (value, index, phase, index2) => {
    const newStep3 = [...step3]
    if (value.value === 'oscar' || value.value === 'king_hele') {
      onFileDelete(index, phase, index2)
      newStep3[index][phase][index2] = {
        keplerian: {
          raan: "",
          sma: "",
          eccentricity: "",
          mean_anomaly: "",
          argument_perigee: "",
          inclination: "",
        },
        type: "base",
        start_epoch: "",
        end_epoch: "",
      }
    } else {

      newStep3[index][phase][index2] = {
        data: "",
        type: "file",
      }
    }
    setStep3(newStep3)
    setlauncherType(value.value)
    setChange(!change)

  }

  const onChangeFile = async (e, index, phase, index2) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(e[0]);
    reader.onload = async () => {
      if (step3[index][phase][index2].data !== '') {
        await db.files
          .where('name')
          .equals(step3[index][phase][index2].data)
          .and((file) => file.phaseName === phase)
          .delete()
      }
      step3[index][phase][index2].data = e[0].name
      await db.files.add({
        name: e[0].name,
        data: e[0],
        orbit: index,
        phaseNumber: index2,
        phaseName: phase,
        pmd: false,
      });


    };

    const newStep3 = [...step3]
    newStep3[index][phase][index2].data = e[0].name
    setChange(!change)
  }

  const onFileDelete = async (index, phase, index2) => {
    if (step3[index][phase][index2].data !== '') {
      await db.files
        .where('name')
        .equals(step3[index][phase][index2].data)
        .and((file) => file.phaseName === phase)
        .delete()
    }
    const newStep3 = [...step3]
    newStep3[index][phase][index2].data = ''
    setStep3(newStep3)
    setChange(!change)

  }

  const onChangeStartDate = (e, index, phase, index2) => {
    const newStep3 = [...step3]


    newStep3[index][phase][index2].start_epoch = e.target.value
    setStep3(newStep3)
    setChange(!change)
  }

  const onChangeEndDate = (e, index, phase, index2) => {
    const newStep3 = [...step3]
    newStep3[index][phase][index2].end_epoch = e.target.value
    setStep3(newStep3)
    setChange(!change)
  }

  const onChangeSemiMajorAxis = (e, index, phase, index2) => {
    const newStep3 = [...step3]
    newStep3[index][phase][index2].keplerian.sma = e.target.value
    setStep3(newStep3)
    setChange(!change)
  }

  const onChangeEccentricity = (e, index, phase, index2) => {
    const newStep3 = [...step3]
    newStep3[index][phase][index2].keplerian.eccentricity = e.target.value
    setStep3(newStep3)
    setChange(!change)
  }

  const onChangeInclination = (e, index, phase, index2) => {
    const newStep3 = [...step3]
    newStep3[index][phase][index2].keplerian.inclination = e.target.value
    setStep3(newStep3)
    setChange(!change)
  }

  const onChangeArgumentOfPeriapsis = (e, index, phase, index2) => {
    const newStep3 = [...step3]
    newStep3[index][phase][index2].keplerian.argument_perigee = e.target.value
    setStep3(newStep3)
    setChange(!change)
  }

  const onChangeMeanAnomaly = (e, index, phase, index2) => {
    const newStep3 = [...step3]
    newStep3[index][phase][index2].keplerian.mean_anomaly = e.target.value
    setStep3(newStep3)
    setChange(!change)
  }

  const onChangeLongitudeOfAscendingNode = (e, index, phase, index2) => {
    const newStep3 = [...step3]
    newStep3[index][phase][index2].keplerian.raan = e.target.value
    setStep3(newStep3)
    setChange(!change)

  }
  const nextStep = () => {
    sessionStorage.setItem('thirdStep', JSON.stringify(step3))
    if (architectureType === 'constellation') {
      sessionStorage.setItem('fourthStepConstellation', JSON.stringify(step4))
    }
    props.handleNext()
  }

  const duplicatePhase = () => {
    const newStep3 = [...step3]
    const launchPhase = JSON.stringify(newStep3[0].launchPhase)
    newStep3[0].operationalOribitInjectionPhase = JSON.parse(launchPhase)
    newStep3[0].operationalPhase = JSON.parse(launchPhase)
    setStep3(newStep3)


  }
  const duplicateOrbit = () => {
    const newStep3 = [...step3]
    const launchPhase = JSON.stringify(newStep3[0].launchPhase)
    const operationalOribitInjectionPhase = JSON.stringify(newStep3[0].operationalOribitInjectionPhase)
    const operationalPhase = JSON.stringify(newStep3[0].operationalPhase)
    for (let i = 1; i < orbits; i++) {
      newStep3[i] = {
        operationalOribitInjectionPhase: JSON.parse(operationalOribitInjectionPhase),
        operationalPhase: JSON.parse(operationalPhase),
        launchPhase: JSON.parse(launchPhase)

      }
    }
    setStep3(newStep3)

    if (architectureType === 'constellation') {
      const newStep4 = [...step4]
      const PMDPhase = JSON.stringify(newStep4[0])
      for (let i = 1; i < orbits; i++) {
        newStep4[i] = JSON.parse(PMDPhase)
      }
      setStep4(newStep4)
    }

  }

  const getSelectValue = (value) => {
    if (value.type === 'base' || value === 'base') {
      return 'oscar'
    } else if (value.type === 'file' || value === 'file') {
      return 'file'
    } else if (value.type === 'king_hele' || value === 'king_hele') {
      return 'king_hele'
    }
  }

  const getSelectLabel = (value) => {
    if (value.type === 'base' || value === 'base') {
      return 'Manual'
    } else if (value.type === 'file' || value === 'file') {
      return 'File(OEM)'
    } else if (value.type === 'king_hele' || value === 'king_hele') {
      return 'King-Hele'
    }
  }

  function CustomToggle({ children, eventKey }) {
    const decoratedOnClick = useAccordionButton(eventKey);

    return (
      <button
        type="button"
        style={{ backgroundColor: 'white', border: 'none', width: '100%', textAlign: 'left', margin: 0 }}
        onClick={decoratedOnClick}
      >
        {children}
      </button>
    );
  }

  const getLaunchPhase = (index) => {

    const launchPhase = []
    step3[index].launchPhase.forEach((phase) => {
      if (phase.type && phase.type === 'file') {
        const launchPhaseFileSchema = {
          type: 'file',
          file_name: phase.data,
        }
        launchPhase.push(launchPhaseFileSchema)
      } else {
        const launchPhaseSchema = {
          type: kingHele ? "king_hele" : "oscar",
          end_epoch: phase.end_epoch,
          start_epoch: phase.start_epoch,
          keplerian: {
            raan: parseFloat(phase.keplerian.raan),
            argument_perigee: parseFloat(phase.keplerian.argument_perigee),
            sma: parseFloat(phase.keplerian.sma),
            eccentricity: parseFloat(phase.keplerian.eccentricity),
            inclination: parseFloat(phase.keplerian.inclination),
            mean_anomaly: parseFloat(phase.keplerian.mean_anomaly),
          },
        }
        launchPhase.push(launchPhaseSchema)
      }


    })
    return launchPhase
  }

  const getLauncherPhase = () => {
    const launchPhase = []
    if (launcherType === 'file') {
      const launchPhaseFileSchema = {
        type: 'file',
        file_name: step3[0].launchPhase[0].data,
      }
      launchPhase.push(launchPhaseFileSchema)
    } else if (launcherType === 'king_hele') {
      launchPhase.push({
        type: "king_hele",
        keplerian: {
          mean_anomaly: parseFloat(step4[0].meanAnomaly),
          eccentricity: parseFloat(step4[0].eccentricity),
          inclination: parseFloat(step4[0].inclination),
          raan: parseFloat(step4[0].rightAscension),
          argument_perigee: parseFloat(step4[0].argumentOfPerigee),
          sma: parseFloat(step4[0].semiMajorAxis),
        },
        start_epoch: new Date(step4[0].startEpoch),
        acs: parseFloat(step4[0].crossSection),
        drag_coefficient: parseFloat(step4[0].dragCoefficient),
      })
    }
    else {
      launchPhase.push({
        type: "oscar",
        keplerian: {
          mean_anomaly: parseFloat(step4[0].meanAnomaly),
          eccentricity: parseFloat(step4[0].eccentricity),
          inclination: parseFloat(step4[0].inclination),
          raan: parseFloat(step4[0].rightAscension),
          argument_perigee: parseFloat(step4[0].argumentOfPerigee),
          sma: parseFloat(step4[0].semiMajorAxis),
        },
        disposal_option: {
          type: 'no_disposal',
          reflectivity_coefficient: parseFloat(step4[0].reflectivityCoefficient),
          drag_coefficient: parseFloat(step4[0].dragCoefficient),
          acs: parseFloat(step4[0].crossSection),
          start_epoch: new Date(step4[0].startEpoch),
        }
      })
    }
    return launchPhase
  }
  const getAssociatedTo = (associatedTo) => {
    const associatedToSchema = []
    associatedTo.forEach((associated) => {
      associatedToSchema.push({
        weighted_value: parseFloat(associated?.weightedValue || associated?.weighted_value) || 0,
        spacecraft_id: parseInt(associated?.spacecraftId || associated?.spacecraft_id),
      })
    })
    return associatedToSchema
  }
  const getFilesAndZip = async () => {
    const fileArray = await db.files.toArray();
    const zip = new JSZip();
    if (!fileArray || !fileArray.length) return;
    fileArray.forEach((file) => {
      zip.file(file.name, file.data);
    });
    const content = await zip.generateAsync({ type: 'blob' });
    return content;
  }
  const sendLauncherMissionForm = async () => {
    const step1 = JSON.parse(sessionStorage.getItem('firstStep'))
    const step2 = JSON.parse(sessionStorage.getItem('secondStep'))
    const type = step1.architectureType
    const missionBody = {
      mission: {
        architecture: step1.architectureType,
        name: step1.missions,
        draft: true,
        version: step1.version,
      },
      space_vehicle: {
        type: type,
        associated_to: getAssociatedTo(step1?.associatedTo),
        active: step2[0]?.MissionOperation.camStatus === 'active',
        debris_trackability: step2[0]?.MissionOperation.debrisTrackability,
        object_type: 'Ariane',
        acs: parseFloat(step2[0]?.SpacecraftDesign.cross) || 0,
        mass: parseFloat(step2[0]?.SpacecraftDesign.mass) || 0,
        phases: {
          launch: getLauncherPhase(),
        }
      }
    }
    const filesZip = await getFilesAndZip()
    if (filesZip) {
      const formData = new FormData()
      formData.append('entire_mission', JSON.stringify(missionBody))
      formData.append('oem_zip_file', filesZip)
      await postPetition('/api/mission/entire_mission', formData)
        .then((response) => {
          if (response?.mission_id) {

            postPetition(`/api/processing/calculate_environmental_impact_index?mission_id=${response.mission_id}`)
              .then((res) => {

                if (res.task_id) {
                  db.files.clear();
                  const user = JSON.parse(sessionStorage.getItem('user'))
                  sessionStorage.clear()
                  sessionStorage.setItem('user', JSON.stringify(user))
                  navigate(`/impact-evaluation/loading/${response.mission_id}/${res.task_id}`)
                }
              })
              .catch((err) => {
                console.log(err)
                toast.error('An error occurred while calculating the mission')
              })
          }
        })
        .catch((err) => {
          console.log(err)
          toast.error('An error occurred while creating the mission')
        })
    }
    else {
      const formData = new FormData()
      formData.append('entire_mission', JSON.stringify(missionBody))
      formData.append('oem_zip_file', '')
      await postPetition('/api/mission/entire_mission', formData)
        .then((response) => {
          if (response?.mission_id) {

            postPetition(`/api/processing/calculate_environmental_impact_index?mission_id=${response.mission_id}`)
              .then((res) => {
                if (res.task_id) {
                  db.files.clear();
                  const user = JSON.parse(sessionStorage.getItem('user'))
                  sessionStorage.clear()
                  sessionStorage.setItem('user', JSON.stringify(user))
                  navigate(`/impact-evaluation/loading/${response.mission_id}/${res.task_id}`)
                }
              })
              .catch((err) => {
                console.log(err)
                toast.error('An error occurred while calculating the mission')
              })
          }
        })
        .catch((err) => {
          console.log(err)
          toast.error('An error occurred while creating the mission')
        })
    }

  }

  const changeStarEpoch = (e, index) => {
    setStep4((prevState) => {
      const newStep4 = [...prevState]
      newStep4[index].startEpoch = e
      return newStep4
    })
  }

  const changeSemiMajorAxis_ = (e, index) => {
    setStep4((prevState) => {
      const newStep4 = [...prevState]
      newStep4[index].semiMajorAxis = e
      return newStep4
    })
  }
  const changeEccentricity_ = (e, index) => {
    setStep4((prevState) => {
      const newStep4 = [...prevState]
      newStep4[index].eccentricity = e
      return newStep4
    })
  }
  const changeInclination_ = (e, index) => {
    setStep4((prevState) => {
      const newStep4 = [...prevState]
      newStep4[index].inclination = e
      return newStep4

    })
  }

  const changeCrossSection = (e, index) => {
    setStep4((prevState) => {
      const newStep4 = [...prevState]
      newStep4[index].crossSection = e
      return newStep4

    })
  }
  const changeDragCoefficient = (e, index) => {
    setStep4((prevState) => {
      const newStep4 = [...prevState]
      newStep4[index].dragCoefficient = e
      return newStep4

    })
  }
  const changeReflectivityCoefficient_ = (e, index) => {
    setStep4((prevState) => {
      const newStep4 = [...prevState]
      newStep4[index].reflectivityCoefficient = e
      return newStep4

    })
  }
  const changeRightAscension_ = (e, index) => {
    setStep4((prevState) => {
      const newStep4 = [...prevState]
      newStep4[index].rightAscension = e
      return newStep4

    })

  }
  const changeArgumentOfPerigee_ = (e, index) => {
    setStep4((prevState) => {
      const newStep4 = [...prevState]
      newStep4[index].argumentOfPerigee = e
      return newStep4

    })
  }
  const changemMeanAnomaly_ = (e, index) => {
    setStep4((prevState) => {
      const newStep4 = [...prevState]
      newStep4[index].meanAnomaly = e
      return newStep4

    })

  }

  if (!loading) {
    return null
  }

  return (
    <Container style={{ justifyContent: 'center', alignItems: 'center', overflowY: 'auto', width: '100%', height: '100%', paddingBottom: '100px', }}>
      {orbits > 1 && (
        <Row >
          <Col xs={12} style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
            <Button style={{ background: '#003247' }} onClick={() => duplicateOrbit()}>Copy plane data</Button>
          </Col>
        </Row>
      )}
      {
        architectureType !== 'constellation' && architectureType !== 'launcher' &&
        <Row >
          <Col xs={12} style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
            <Button disabled={disabled} style={{ background: '#003247' }} onClick={() => duplicatePhase()}>Copy plane data</Button>
          </Col>
        </Row>
      }
    
      {
        [
          ...Array(orbits),
        ].map((value, index) => (
          <>
          
            <Accordion defaultActiveKey={index}>
              <Accordion.Item eventKey={index}>
                {
                  architectureType === 'constellation' &&
                  <Row style={{ paddingBottom: '15px' }}>

                  <Col xs={12}>
                    <Card.Header style={{ color: 'white', padding: '0' }}>
                      <CustomToggle eventKey={index} >
                        <h1 style={{ color: '#003247' }}>Plane {index + 1}</h1>
                      </CustomToggle>
                    </Card.Header>
                  </Col>
                </Row>
                }
                
                <Accordion.Body>
                  {
                    architectureType === 'launcher' &&
                    (
                      <div className={style.phaseCard}>

                        <Row className={style.rowForm}>
                          <Col xs={3}  >
                            <Select
                              isDisabled={disabled}
                              className="react-select"
                              classNamePrefix="react-select"
                              value={{ value: getSelectValue(launcherType), label: getSelectLabel(launcherType) }}
                              onChange={(value) => onChangeLauncherType(value, index, 'launchPhase', 0)}
                              options={[
                                { value: 'file', label: 'File(OEM)' },
                                { value: 'base', label: 'Manual' },
                                { value: 'king_hele', label: 'King-Hele' },
                              ]}></Select>
                          </Col>

                          <Col xs={12} >
                            {
                              launcherType && launcherType === 'file' &&
                              <Col xs={12} >
                                <FileUpload
                                  stepIndex={index}
                                  phase={'launchPhase'}
                                  indexPhase={0}
                                  disabled={disabled}
                                  onFileDelete={onFileDelete}
                                  showPreview={true}
                                  onFileUpload={(files) => {
                                    onChangeFile(files, index, 'launchPhase', 0)
                                  }}
                                />
                              </Col>
                            }
                            {launcherType && (launcherType === 'base' || launcherType === 'king_hele') &&
                              <>
                                <Row>
                                  <Col xs={12} md={12} >
                                    <GeneralInputs
                                      disabled={disabled}
                                      step4={step4[index]}
                                      orbit={index}
                                      changeStarEpoch={changeStarEpoch}
                                      changeCrossSection={changeCrossSection}
                                      changeDragCoefficient={changeDragCoefficient}
                                      changeReflectivityCoefficient={changeReflectivityCoefficient_}
                                    />
                                  </Col>
                                </Row>
                                <Row>
                                  <Col xs={12} md={12} >
                                    <KeplerianInputs
                                      step4={step4[index]}
                                      disabled={disabled}
                                      orbit={index}
                                      changeSemiMajorAxis={changeSemiMajorAxis_}
                                      changeEccentricity={changeEccentricity_}
                                      changeInclination={changeInclination_}
                                      changeRightAscension={changeRightAscension_}
                                      changeArgumentOfPerigee={changeArgumentOfPerigee_}
                                      changemMeanAnomaly={changemMeanAnomaly_}
                                    />
                                  </Col>
                                </Row>
                              </>
                            }
                          </Col>
                        </Row>
                      </div>
                    )
                  }
                  {
                    architectureType !== 'launcher' &&
                    <>
                      <Row style={{ paddingBottom: '15px' }}>
                        <Col xs={12}>
                          <h3 style={{ color: '#003247' }}>Launch phase</h3>
                        </Col>
                        {step3[index] && step3[index].launchPhase && step3[index].launchPhase.map((launchPhase) => (
                          <div className={style.phaseCard}>
                            <Col xs={12}>
                              <Row className={style.rowForm}>
                                <Col xs={3}  >
                                  <Select
                                    isDisabled={disabled}
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    value={{ value: getSelectValue(launchPhase), label: getSelectLabel(launchPhase) }}
                                    onChange={(value) => onChangeInputType(value, index, 'launchPhase', 0)}
                                    options={[
                                      { value: 'file', label: 'File(OEM)' },
                                      { value: 'oscar', label: 'Manual' },
                                    ]}></Select>
                                </Col>
                                {
                                  launchPhase.type && launchPhase.type === 'file' ?
                                    <Col xs={12} >
                                      <FileUpload
                                        stepIndex={index}
                                        phase={'launchPhase'}
                                        indexPhase={0}
                                        disabled={disabled}
                                        onFileDelete={onFileDelete}
                                        showPreview={true}
                                        onFileUpload={(files) => {
                                          onChangeFile(files, index, 'launchPhase', 0)
                                        }}
                                      />
                                    </Col>
                                    : null
                                }
                              </Row>
                            </Col>
                            {
                              launchPhase.type && launchPhase.type === 'base' &&
                              <Col xs={12}>
                                <ManualInput
                                  disabled={disabled}
                                  index={index}
                                  step3={step3}
                                  indexPhase={0}
                                  phase={'launchPhase'}
                                  changeStartDate={onChangeStartDate}
                                  changeEndDate={onChangeEndDate}
                                  changeSemiMajorAxis={onChangeSemiMajorAxis}
                                  changeEccentricity={onChangeEccentricity}
                                  changeInclination={onChangeInclination}
                                  changeArgumentOfPeriapsis={onChangeArgumentOfPeriapsis}
                                  changeLongitudeOfAscendingNode={onChangeLongitudeOfAscendingNode}
                                  changeMeanAnomaly={onChangeMeanAnomaly}
                                />
                              </Col>
                            }
                          </div>
                        ))}

                      </Row>
                      <Row style={{ paddingBottom: '15px' }}>
                        <Col xs={12} style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
                          <h3 style={{ color: '#003247' }}>Operational Orbit Injection Phase</h3>
                          <Button disabled={disabled} onClick={() => addOperationalInjectionPhase(index)} variant={'light'} className="btn-icon " style={{ borderColor: '#003247', }}>
                            <i className={classNames('mdi', 'mdi-pen-plus',)}></i>
                          </Button>
                        </Col>
                        {step3[index] && step3[index].operationalOribitInjectionPhase && step3[index].operationalOribitInjectionPhase.map((operationalInjection, index2) => (
                          <div className={style.phaseCard}>
                            <Col xs={12}>
                              <Row className={style.rowForm}>
                                <Col xs={3}>
                                  <Select
                                    isDisabled={disabled}
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    value={{ value: getSelectValue(operationalInjection), label: getSelectLabel(operationalInjection) }}
                                    onChange={(value) => onChangeInputType(value, index, 'operationalOribitInjectionPhase', index2)}
                                    options={[
                                      { value: 'file', label: 'File(OEM)' },
                                      { value: 'oscar', label: 'Manual' },
                                    ]}></Select>
                                </Col>
                                {
                                  operationalInjection.type === 'file' ?

                                    <Col xs={12} >
                                      <FileUpload
                                        showPreview={true}
                                        stepIndex={index}
                                        phase={'operationalOribitInjectionPhase'}
                                        indexPhase={index2}
                                        onFileDelete={onFileDelete}
                                        disabled={disabled}
                                        onFileUpload={(files) => {
                                          onChangeFile(files, index, 'operationalOribitInjectionPhase', index2)
                                        }}
                                      />
                                    </Col>

                                    : null
                                }
                              </Row>
                            </Col>
                            {
                              operationalInjection.type && operationalInjection.type === "base" &&
                              <Col xs={12}>
                                <ManualInput
                                  disabled={disabled}
                                  index={index}
                                  indexPhase={index2}
                                  step3={step3}
                                  phase={'operationalOribitInjectionPhase'}
                                  changeStartDate={onChangeStartDate}
                                  changeEndDate={onChangeEndDate}
                                  changeSemiMajorAxis={onChangeSemiMajorAxis}
                                  changeEccentricity={onChangeEccentricity}
                                  changeInclination={onChangeInclination}
                                  changeArgumentOfPeriapsis={onChangeArgumentOfPeriapsis}
                                  changeLongitudeOfAscendingNode={onChangeLongitudeOfAscendingNode}
                                  changeMeanAnomaly={onChangeMeanAnomaly}
                                />
                              </Col>
                            }
                            {index2 > 0 &&
                              <Col xs={12} style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px' }}>
                                <Button disabled={disabled} onClick={() => removeOperationalInjectionPhase(index, index2)} variant={'light'} className="btn-icon " style={{ borderColor: '#003247', }}>
                                  <i className={classNames('mdi', 'mdi-delete',)}></i>
                                </Button>
                              </Col>
                            }

                          </div>
                        ))}

                      </Row>
                      <Row style={{ paddingBottom: '15px' }}>
                        <Col xs={12} style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
                          <h3 style={{ color: '#003247' }}>Operational Phase</h3>
                          <Button disabled={disabled} onClick={() => addOperationalPhase(index)} variant={'light'} className="btn-icon " style={{ borderColor: '#003247', }}>
                            <i className={classNames('mdi', 'mdi-pen-plus',)}></i>
                          </Button>
                        </Col>

                        {step3[index] && step3[index].operationalPhase && step3[index].operationalPhase.map((operationalPhase, index2) => (
                          <div className={style.phaseCard}>
                            <Col xs={12}>
                              <Row className={style.rowForm}>
                                <Col xs={3}>
                                  <Select
                                    isDisabled={disabled}
                                    value={{ value: getSelectValue(operationalPhase), label: getSelectLabel(operationalPhase) }}
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    onChange={(value) => onChangeInputType(value, index, 'operationalPhase', index2)}
                                    options={[
                                      { value: 'file', label: 'File(OEM)' },
                                      { value: 'oscar', label: 'Manual' },
                                    ]}></Select>
                                </Col>
                                {
                                  operationalPhase.type === 'file' ?
                                    <Col xs={12} >
                                      <FileUpload
                                        stepIndex={index}
                                        phase={'operationalPhase'}
                                        indexPhase={index2}
                                        onFileDelete={onFileDelete}
                                        disabled={disabled}
                                        showPreview={true}
                                        onFileUpload={(files) => {
                                          onChangeFile(files, index, 'operationalPhase', index2)
                                        }}
                                      />
                                    </Col>
                                    : null
                                }
                              </Row>
                            </Col>
                            {
                              operationalPhase.type && operationalPhase.type === 'base' &&
                              <Col xs={12}>
                                <ManualInput
                                  disabled={disabled}
                                  index={index}
                                  indexPhase={index2}
                                  phase={'operationalPhase'}
                                  step3={step3}
                                  changeStartDate={onChangeStartDate}
                                  changeEndDate={onChangeEndDate}
                                  changeSemiMajorAxis={onChangeSemiMajorAxis}
                                  changeEccentricity={onChangeEccentricity}
                                  changeInclination={onChangeInclination}
                                  changeArgumentOfPeriapsis={onChangeArgumentOfPeriapsis}
                                  changeLongitudeOfAscendingNode={onChangeLongitudeOfAscendingNode}
                                  changeMeanAnomaly={onChangeMeanAnomaly}
                                />
                              </Col>
                            }
                            {
                              index2 > 0 &&

                              <Col xs={12} style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px' }}>
                                <Button disabled={disabled} onClick={() => removeOperationalPhase(index, index2)} variant={'light'} className="btn-icon " style={{ borderColor: '#003247', }}>
                                  <i className={classNames('mdi', 'mdi-delete',)}></i>
                                </Button>
                              </Col>
                            }

                          </div>
                        ))}

                      </Row>
                      {
                        architectureType === 'constellation' &&
                        <Row style={{ paddingBottom: '15px' }}>
                          <Col xs={12} style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
                            <h3 style={{ color: '#003247' }}>PMD initial data</h3>
                          </Col>
                          <div className={style.phaseCard}>
                            <>
                              <Row>
                                <Col xs={12} md={12} >
                                  <GeneralInputs
                                    disabled={disabled}
                                    step4={step4[index]}
                                    orbit={index}
                                    changeStarEpoch={changeStarEpoch}
                                    changeCrossSection={changeCrossSection}
                                    changeDragCoefficient={changeDragCoefficient}
                                    changeReflectivityCoefficient={changeReflectivityCoefficient_}
                                  />
                                </Col>
                              </Row>
                              <Row>
                                <Col xs={12} md={12} >
                                  <KeplerianInputs
                                    step4={step4[index]}
                                    disabled={disabled}
                                    orbit={index}
                                    changeSemiMajorAxis={changeSemiMajorAxis_}
                                    changeEccentricity={changeEccentricity_}
                                    changeInclination={changeInclination_}
                                    changeRightAscension={changeRightAscension_}
                                    changeArgumentOfPerigee={changeArgumentOfPerigee_}
                                    changemMeanAnomaly={changemMeanAnomaly_}
                                  />
                                </Col>
                              </Row>
                            </>
                          </div>

                        </Row>
                      }

                    </>

                  }

                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </>
        ))
      }
        <div className={style.textInfo}>
            <h4>Evaluation discarding unneeded phases.</h4>
            The current version of the WUI require the use of all the specified phases. In the case the user wants to discard some of them, it is possible to do it by selecting the <span style={{ fontWeight: 'bold' }}> Start Date </span> and the  <span style={{ fontWeight: 'bold' }}>  End Date </span> with one day's difference. In this way, the impact of these phases will be negligible (although it will still appear in the final results).
          </div>
      <Row>
        <Col xs={12}>
          <div style={{ paddingTop: '20px', paddingBottom: '20px', display: 'flex', gap: '10px' }}>
            <Button style={{ background: '#003247', borderColor: '#003247' }} onClick={props.handleBack}>
              Previous
            </Button>
            {
              (disabled && architectureType === 'launcher') ? (<></>) :
                <Button disabled={validateForm()} style={{ background: '#003247', borderColor: '#003247' }} onClick={architectureType === 'launcher' ? sendLauncherMissionForm : nextStep}>
                  {architectureType === 'launcher' ? 'Compute Debris Index' : 'Next'}
                </Button>
            }

          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default MissionPhases